import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'
import { CATEGORY_COLORS, getTheme } from './chartTheme'
import ChartTooltip from './ChartTooltip'

const ExpenseBarChart = ({ data = [], height = 300, isDark = false }) => {
  const { t } = useTranslation('common')
  const theme = getTheme(isDark)

  const chartData = data.map((item, i) => ({
    name: item.name || item.category?.name || t('noCategory'),
    kwota: parseFloat(item.amount || item.total || 0),
    fill: CATEGORY_COLORS[i % CATEGORY_COLORS.length],
  }))

  if (chartData.length === 0) {
    return (
      <div className="flex items-center justify-center" style={{ height, color: 'var(--color-text-faint)' }}>
        {t('noData')}
      </div>
    )
  }

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={chartData} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
        <CartesianGrid
          strokeDasharray="3 3"
          stroke={theme.grid}
          vertical={false}
        />
        <XAxis
          dataKey="name"
          axisLine={false}
          tickLine={false}
          tick={{ fill: theme.textSecondary, fontSize: 11 }}
          angle={-20}
          textAnchor="end"
          height={50}
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          tick={{ fill: theme.textSecondary, fontSize: 12 }}
          tickFormatter={(val) => `${val} ${t('currency')}`}
          width={70}
        />
        <Tooltip content={<ChartTooltip />} />
        <Bar
          dataKey="kwota"
          radius={[6, 6, 0, 0]}
          maxBarSize={48}
        >
          {chartData.map((entry, index) => (
            <rect key={index} fill={entry.fill} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )
}

export default ExpenseBarChart
